// @ts-nocheck
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useQueryFetch } from 'sonata-react-components';

import { downloadReport } from '@/modules/reporting/reporting.resources';
import { getBaseCurrencyName } from '@/store/selectors/baseCurrency.selectors';
import { getSelectedCampaigns } from '@/store/selectors/reporting.selectors';
import { getCurrency } from '@/store/selectors/reportingAdvancedFilter.selectors';
import { getUserId } from '@/store/selectors/user.selectors';

import type { ExportFileFormat, TabOptions } from '../types';

export function useReportDownloadRequest(name: string, tabsOptions: TabOptions[], type: ExportFileFormat) {
  const baseCurrency = useSelector(getBaseCurrencyName);
  const campaigns = useSelector(getSelectedCampaigns);
  const campaignsIds = campaigns.map((campaign: any) => campaign.id);
  const currentCurrency = useSelector(getCurrency);
  const userId = useSelector(getUserId);
  const tabs = type === 'csv' ? [tabsOptions[0]] : tabsOptions;

  const currencyOptions = {
    baseCurrency,
    currency: currentCurrency
  };

  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  const { data, isLoading } = useQueryFetch(
    ['downloadReport', name, tabs, type],
    async () => downloadReport(userId, currencyOptions, tabs, type, campaignsIds, name),
    {
      enabled: isDownloading
    }
  );

  if (data && !isLoading && isDownloading) {
    window.open(data.urlLink);
    setIsDownloading(false);
  }

  return {
    downloadReport: () => setIsDownloading(true),
    isLoading
  };
}
